// extracted by mini-css-extract-plugin
export var actions = "_mu-5";
export var assistantBubble = "_mu-3";
export var assistantRow = "_mu-6";
export var bubble = "_mu-0";
export var humanAvatar = "_mu-4";
export var inlineToolCard = "_mu-1";
export var userBubble = "_mu-2";